export default `
	guid
	created_at
	log_value
	
	booking {
		booking_date
		
		employee {
			guid
			name
			email
		}
		
		timeslot {
			timeslot_start
			timeslot_end
		}
	}
`;
